export default "__VITE_ASSET__WDM3duM0__"